import { formatISODuration, getDurationParts } from '~/jet/models';

interface CachedFormatters {
    number: Intl.NumberFormat;
    numberPadded: Intl.NumberFormat;
}
let formattersByLanguage: Record<string, CachedFormatters> = {};
/*
 * Utility to format a hh:mm:ss time from raw seconds.
 * Source:
 *
 * @method formatDuration
 * @public
 * @param {Integer} seconds
 * @param {String} locale
 * @returns {String} durationString
 */
export function formatDuration(sec: number, locale: string): string {
    // TODO: rdar://92328740 (JMOTW: formatDuration util change to getting duration in milliseconds instead of seconds)
    // Save the format functions once until the local changes (edge case)
    let formatters =
        formattersByLanguage[locale] ||
        (formattersByLanguage[locale] = {
            number: Intl.NumberFormat(locale, { minimumIntegerDigits: 1 }),
            numberPadded: Intl.NumberFormat(locale, {
                minimumIntegerDigits: 2,
            }),
        });
    let format = formatters.number.format;
    let formatPadded = formatters.numberPadded.format;

    if (sec) {
        const [delimiter = ':'] =
            new Date().toLocaleTimeString(locale).match(/\b[:.]\b/) || [];
        const { hours, minutes, seconds } = getDurationParts(sec);

        if (hours) {
            return [
                format(hours),
                formatPadded(minutes),
                formatPadded(seconds),
            ].join(delimiter);
        } else {
            return [format(minutes), formatPadded(seconds)].join(delimiter);
        }
    }
    return '';
}

export { formatISODuration, getDurationParts };
